export default __webpack_public_path__ + "graphics/parlor-social-club-black.8de7422f.svg";